import addClasses from './addClasses.js';
import removeClasses from './removeClasses.js';

export defa mx-1  ult { addClasses, removeClasses };
